class SingleProduct {
  constructor() {
    this.variationsFormSelector = '.mad-variations-form';
    this.variationsForm = jQuery(this.variationsFormSelector);

    var resetVariations = jQuery('form.mad-variations-form .reset_variations');
    setTimeout(() => {
      resetVariations.addClass('initialized');
    }, 500);

    jQuery(document).on('click', 'button.mad-add-to-cart__plus-quantity-button, button.mad-add-to-cart__minus-quantity-button', function () {
      var qty = jQuery(this).closest('form.cart').find('.qty');
      var val = parseFloat(qty.val());
      var max = parseFloat(qty.attr('max'));
      var min = parseFloat(qty.attr('min'));
      var step = parseFloat(qty.attr('step'));
      if (jQuery(this).is('.mad-add-to-cart__plus-quantity-button')) {
        if (max && (max <= val)) {
          qty.val(max);
        } else {
          qty.val(val + step);
        }
      } else {
        if (min && (min >= val)) {
          qty.val(min);
        } else if (val > 1) {
          qty.val(val - step);
        }
      }
      qty.trigger('change');
    });

    // Delegate event handling for variation form to the document
    jQuery(document).on('change', this.variationsFormSelector, this.updatePrice.bind(this));

    this.updatePrice();
  }

  updatePrice() {
    // console.log('updatePrice');
    this.variationsForm = jQuery(this.variationsFormSelector);
    if (this.variationsForm.length == 0) return;

    var currentVariations = this.variationsForm.data('product_variations');
    var selectedOptions = {};

    this.variationsForm.find('.variations select, .variations input[type="text"]').each(function () {
      var attribute = jQuery(this).data('attribute_name') || jQuery(this).attr('name');
      selectedOptions[attribute] = jQuery(this).val();
    });

    // console.log('selectedOptions', selectedOptions);

    // Filter out any wck attributes from selectedOptions
    var filteredSelectedOptions = {};
    for (var key in selectedOptions) {
      if (!key.startsWith('wck[')) {
        filteredSelectedOptions[key] = selectedOptions[key];
      }
    }

    var matchingVariations = currentVariations.filter(function (variation) {
      for (var attribute in filteredSelectedOptions) {
        // console.log(`Comparing: ${attribute} - selected: ${filteredSelectedOptions[attribute]}, variation: ${variation.attributes[attribute]}`);
        if (filteredSelectedOptions[attribute] && variation.attributes[attribute] !== filteredSelectedOptions[attribute]) {
          return false;
        }
      }
      return true;
    });

    // console.log('matchingVariations', matchingVariations);

    if (matchingVariations.length) {
      var prices = matchingVariations.map(function (variation) {
        return variation.display_price;
      });

      var minPrice = Math.min.apply(Math, prices);
      var maxPrice = Math.max.apply(Math, prices);

      // console.log('minPrice', minPrice);
      // console.log('maxPrice', maxPrice);

      if (minPrice === maxPrice) {
        jQuery('.mad-price-incl-tax').text(this.formatPrice(minPrice));
        var priceExclTax = this.calculatePriceExcludingTax(minPrice, matchingVariations[0].tax_info);
        jQuery('.mad-price-excl-tax').text(this.formatPrice(priceExclTax));
      } else {
        jQuery('.mad-price-incl-tax').text(this.formatPrice(minPrice) + ' – ' + this.formatPrice(maxPrice));
        var priceExclTaxMin = this.calculatePriceExcludingTax(minPrice, matchingVariations[0].tax_info);
        var priceExclTaxMax = this.calculatePriceExcludingTax(maxPrice, matchingVariations[0].tax_info);
        jQuery('.mad-price-excl-tax').text(this.formatPrice(priceExclTaxMin) + ' – ' + this.formatPrice(priceExclTaxMax));
      }
    }
  }

  calculatePriceExcludingTax(price, taxInfo) {
    if (!taxInfo) return price;
    var taxRateMatch = taxInfo.match(/(\d+(\.\d+)?)\s*%/);
    if (taxRateMatch) {
      var taxRate = parseFloat(taxRateMatch[1]);
      var priceExclTax = price / (1 + (taxRate / 100));
      return priceExclTax;
    }
    return price;
  }

  formatPrice(price) {
    return new Intl.NumberFormat('de-DE', {
      style: 'currency',
      currency: 'EUR'
    }).format(price);
  }
}

window.$singleProduct = new SingleProduct();